/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class GroupMemberType {
    static Normal = 0;
    static Manager = 1;
    static Owner = 2;
    static Muted = 3;
    static Removed = 4;
    static Allowed = 5;
}
